export default __webpack_public_path__ + "static/media/Capture.3871c59a.mp3";